import Api from '@/services/Api'

export default {
  verifyAdmin () {
    return Api().get('tpc/admin/', {})
  },

  addScrambles (params) {
    return Api().post('tpc/admin/add_scrambles', params)
  },

  createEvent (params)  {
    return Api().post('tpc/admin/create_event', params)
  },
  updateRound (params) {
    return Api().post('tpc/admin/update_round', params)
  },

  updateResult (params) {
    return Api().post('tpc/admin/update_result', params)
  },
  clearResults (params) {
    return Api().post('tpc/admin/clear_results', params)
  },

  getEmails (type, params) {
    return Api().get(`tpc/admin/emails/${type}`, {params})
  },

  getWcaInfo (params) {
    return Api().get('tpc/admin/wca_info', {params})
  },
}
